import React, {useEffect, useState} from 'react';
import { Tab, Row, Col, Nav, Modal } from 'react-bootstrap';
import { ThemeConsumer } from '../context/ThemeContext';
import { Link } from "react-router-dom";
import '../assets/scss/layout/modal.scss'

export default function Wallet() {
  const [btcBalance, setBtcBalance] = useState(0);
  const [btcPrice, setBtcPrice] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [transactions, setTransactions] = useState([]);
  
  // Modal states
  const [showDepositModal, setShowDepositModal] = useState(false);
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  
  // Copy button states
  const [copiedWallet, setCopiedWallet] = useState(false);
  const [copiedModal, setCopiedModal] = useState(false);
  
  // Withdraw form states
  const [withdrawAddress, setWithdrawAddress] = useState("");
  const [withdrawBTC, setWithdrawBTC] = useState("");
  const [withdrawUSD, setWithdrawUSD] = useState("");
  const [withdrawing, setWithdrawing] = useState(false);

  const DEPOSIT_ADDRESS = "bc1qkle5tfunecw3555huh86eqjex283cyde87sma4";

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setError("User not logged in");
      setLoading(false);
      return;
    }

    async function loadData() {
      try {
        // Fetch BTC balance
        const balanceRes = await fetch("https://swiftexprofit.com/user/balance", {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (!balanceRes.ok) throw new Error("Failed to fetch balance");
        const balanceData = await balanceRes.json();
        setBtcBalance(balanceData.balance);

        // Fetch BTC price
        const priceRes = await fetch("https://swiftexprofit.com/price/btc");
        if (!priceRes.ok) throw new Error("Failed to fetch BTC price");
        const priceData = await priceRes.json();
        setBtcPrice(priceData.btc_usd);

        setLoading(false);
      } catch (err) {
        console.error(err);
        setError(err.message || "Something went wrong");
        setLoading(false);
      }
      // Fetch user transactions
      const txRes = await fetch("https://swiftexprofit.com/user/transactions", {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!txRes.ok) throw new Error("Failed to fetch transactions");

      const txData = await txRes.json();
      setTransactions(txData.transactions);
    }

    loadData();
  }, []);

  const usdValue = (btcBalance * btcPrice).toFixed(2);

  const handleCopyAddress = (isModal = false) => {
    navigator.clipboard.writeText(DEPOSIT_ADDRESS).then(() => {
      if (isModal) {
        setCopiedModal(true);
        setTimeout(() => setCopiedModal(false), 2000);
      } else {
        setCopiedWallet(true);
        setTimeout(() => setCopiedWallet(false), 2000);
      }
    }).catch(() => {
      alert("Failed to copy address");
    });
  };

  const handleBTCChange = (value) => {
    setWithdrawBTC(value);
    if (value && !isNaN(value) && btcPrice) {
      const usd = (parseFloat(value) * btcPrice).toFixed(2);
      setWithdrawUSD(usd);
    } else {
      setWithdrawUSD("");
    }
  };

  const handleUSDChange = (value) => {
    setWithdrawUSD(value);
    if (value && !isNaN(value) && btcPrice) {
      const btc = (parseFloat(value) / btcPrice).toFixed(8);
      setWithdrawBTC(btc);
    } else {
      setWithdrawBTC("");
    }
  };

  const handleWithdraw = async () => {
    if (!withdrawAddress) {
      alert("Please enter a withdrawal address");
      return;
    }
    if (!withdrawBTC || parseFloat(withdrawBTC) <= 0) {
      alert("Please enter a valid amount");
      return;
    }
    if (parseFloat(withdrawBTC) > btcBalance) {
      alert("Insufficient balance");
      return;
    }

    setWithdrawing(true);
    try {
      // TODO: Implement actual withdrawal API call
      // For now, just simulate a delay
      await new Promise(resolve => setTimeout(resolve, 1500));
      alert("Withdrawal request submitted successfully!");
      setShowWithdrawModal(false);
      setWithdrawAddress("");
      setWithdrawBTC("");
      setWithdrawUSD("");
      // Reload data
      window.location.reload();
    } catch (err) {
      alert("Withdrawal failed: " + err.message);
    } finally {
      setWithdrawing(false);
    }
  };

  return (
    <>
      <div className="settings mtb15">
        <div className="container-fluid">
          <Tab.Container defaultActiveKey="wallet">
            <Row>
              <Col lg={3}>
                <Nav variant="pills" className="settings-nav">
                  <Nav.Item>
                    <Nav.Link as={Link} to="/profile">Profile</Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link as={Link} to="/wallet">Wallet</Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link as={Link} to="/settings">Settings</Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col lg={9}>
                <Tab.Content>
                  <Tab.Pane eventKey="profile">
                    
                  </Tab.Pane>
                  <Tab.Pane eventKey="wallet">
                    <div className="wallet">
                      <Row>
                        <Col lg={4}>
                          <Nav variant="pills" className="settings-nav">
                            <Nav.Item>
                              <Nav.Link
                                eventKey="wallet_BTC"
                                className="d-flex justify-content-between align-items-center active"
                              >
                                <div className="d-flex">
                                  <img src={'img/icon/18.png'} alt="btc" />
                                  <div>
                                    <h2>BTC</h2>
                                    <p>Bitcoin</p>
                                  </div>
                                </div>
                                <div>
                                  <h3>{loading ? "..." : btcBalance.toFixed(8)}</h3>
                                  <p className="text-right">
                                    <i className="icon ion-md-lock"></i>{' '}
                                    0.0000000
                                  </p>
                                </div>
                              </Nav.Link>
                            </Nav.Item>
                            
                          </Nav>
                        </Col>

                        <Col lg={8}>
                          <div className="tab-content">
                            <div
                              className="tab-pane fade show active"
                              id="coinBTC"
                              role="tabpanel"
                            >
                              {loading && <div className="alert alert-info">Loading balance...</div>}
                              {error && <div className="alert alert-danger">{error}</div>}
                              
                              {!loading && !error && (
                                <>
                                  <div className="card">
                                    <div className="card-body">
                                      <h5 className="card-title">Balances</h5>
                                      <ul>
                                        <li className="d-flex justify-content-between align-items-center">
                                          <div className="d-flex align-items-center">
                                            <i className="icon ion-md-cash"></i>
                                            <h2>BTC Balance</h2>
                                          </div>
                                          <div>
                                            <h3>{btcBalance.toFixed(8)} BTC</h3>
                                          </div>
                                        </li>
                                        <li className="d-flex justify-content-between align-items-center">
                                          <div className="d-flex align-items-center">
                                            <i className="icon ion-md-cash"></i>
                                            <h2>USD Value</h2>
                                          </div>
                                          <div>
                                            <h3>${usdValue}</h3>
                                          </div>
                                        </li>
                                        <br/>
                                        <li className="d-flex justify-content-between align-items-center">
                                          <div className="d-flex align-items-center">
                                            <i className="icon ion-md-trending-up"></i>
                                            <h2>BTC Price</h2>
                                          </div>
                                          <div>
                                            <h3>${btcPrice.toLocaleString()}</h3>
                                          </div>
                                        </li>
                                      </ul>
                                      <button className="btn green" onClick={() => setShowDepositModal(true)}>
                                        Deposit
                                      </button>
                                      <button className="btn red" onClick={() => setShowWithdrawModal(true)}>
                                        Withdraw
                                      </button>
                                    </div>
                                  </div>
                                  <div className="card">
                                    <div className="card-body">
                                      <h5 className="card-title">
                                        Wallet Deposit Address
                                      </h5>
                                      <div className="row wallet-address">
                                        <div className="col-md-8">
                                          <p>
                                            Deposits to this address are unlimited.
                                            Note that you may not be able to
                                            withdraw all of your funds at once if
                                            you deposit more than your daily
                                            withdrawal limit.
                                          </p>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={DEPOSIT_ADDRESS}
                                              readOnly
                                            />
                                            <div className="input-group-prepend">
                                              <button 
                                                className="btn btn-primary" 
                                                onClick={() => handleCopyAddress(false)}
                                                style={{ minWidth: '80px' }}
                                              >
                                                {copiedWallet ? (
                                                  <i className="icon ion-md-checkmark"></i>
                                                ) : (
                                                  'COPY'
                                                )}
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-md-4">
                                          <ThemeConsumer>
                                            {({ data }) => {
                                              return data.theme === 'light' ? (
                                                <img
                                                  src={require('../assets/img/qr.png')}
                                                  alt="qr-code"
                                                />
                                              ) : (
                                                <img
                                                  src={require('../assets/img/qr.png')}
                                                  alt="qr-code"
                                                />
                                              );
                                            }}
                                          </ThemeConsumer>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card">
                                    <div className="card-body">
                                      <h5 className="card-title">
                                        Latest Transactions
                                      </h5>
                                      <div className="wallet-history">
                                        <table className="table">
                                          <thead>
                                            <tr>
                                              <th>No.</th>
                                              <th>Date</th>
                                              <th>Type</th>
                                              <th>Status</th>
                                              <th>Amount</th>
                                            </tr>
                                          </thead>

                                          <tbody>
                                            {transactions.length === 0 && (
                                              <tr>
                                                <td colSpan="5">No transactions yet</td>
                                              </tr>
                                            )}

                                            {transactions.map((tx, index) => (
                                              <tr key={tx.id}>
                                                <td>{index + 1}</td>
                                                <td>{new Date(tx.date).toLocaleDateString()}</td>

                                                {/* TYPE */}
                                                <td>
                                                  {tx.type === "deposit" ? (
                                                    <span className="text-success">Deposit</span>
                                                  ) : (
                                                    <span className="text-danger">Withdraw</span>
                                                  )}
                                                </td>

                                                {/* STATUS ICON */}
                                                <td>
                                                  {tx.status === "success" ? (
                                                    <i className="icon ion-md-checkmark-circle-outline green"></i>
                                                  ) : (
                                                    <i className="icon ion-md-close-circle-outline red"></i>
                                                  )}
                                                </td>

                                                {/* AMOUNT */}
                                                <td>
                                                  {tx.type === "deposit" ? "+" : "-"}
                                                  {tx.amount}
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>

                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Tab.Pane>
                  
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </div>

      {/* Deposit Modal */}
      <Modal show={showDepositModal} onHide={() => setShowDepositModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{color: "white"}}>Deposit Bitcoin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center mb-4">
            <ThemeConsumer>
              {({ data }) => (
                <img
                  src={require('../assets/img/qr.png')}
                  alt="qr-code"
                  style={{ maxWidth: '200px' }}
                />
              )}
            </ThemeConsumer>
          </div>
          <p style={{ fontSize: '14px', color: '#666' }}>
            Send Bitcoin to this address. Deposits will be credited after network confirmations.
          </p>
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              value={DEPOSIT_ADDRESS}
              readOnly
              style={{ fontSize: '13px' }}
            />
            <div className="input-group-append">
              <button 
                className="btn btn-primary" 
                onClick={() => handleCopyAddress(true)}
                style={{ minWidth: '80px' }}
              >
                {copiedModal ? (
                  <i className="icon ion-md-checkmark"></i>
                ) : (
                  'COPY'
                )}
              </button>
            </div>
          </div>
          <div className="alert alert-warning" style={{ fontSize: '13px' }}>
            <strong>Important:</strong> Only send Bitcoin (BTC) to this address. Sending any other cryptocurrency will result in permanent loss.
          </div>
        </Modal.Body>
      </Modal>

      {/* Withdraw Modal */}
      <Modal show={showWithdrawModal} onHide={() => setShowWithdrawModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{color: "white"}}>Withdraw Bitcoin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label" style={{color: "white"}}>Withdrawal Address</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Bitcoin address"
              value={withdrawAddress}
              onChange={(e) => setWithdrawAddress(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label" style={{color: "white"}}>Amount (BTC)</label>
            <input
              type="number"
              className="form-control"
              placeholder="0.00000000"
              step="0.00000001"
              value={withdrawBTC}
              onChange={(e) => handleBTCChange(e.target.value)}
            />
            <small className="form-text text-muted" >
              Available: {btcBalance.toFixed(8)} BTC
            </small>
          </div>

          <div className="mb-3">
            <label className="form-label" style={{color: "white"}}>Amount (USD)</label>
            <input
              type="number"
              className="form-control"
              placeholder="0.00"
              step="0.01"
              value={withdrawUSD}
              onChange={(e) => handleUSDChange(e.target.value)}
            />
            <small className="form-text text-muted">
              BTC Price: ${btcPrice.toLocaleString()}
            </small>
          </div>

          <div className="alert alert-info" style={{ fontSize: '13px' }}>
            <strong>Note:</strong> Withdrawals are processed within 24 hours. Network fees may apply.
          </div>

          <button 
            className="btn btn-danger btn-block"
            onClick={handleWithdraw}
            disabled={withdrawing}
          >
            {withdrawing ? 'Processing...' : 'Confirm Withdrawal'}
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
}